export interface AnalyticsQuest {
  id: string
  name: string
}
export enum AnalyticsEventType {
  USER_SESSION_START = 'session_start',
  USER_NEW_USER_CREATED = 'new_user_created',
  USER_RETURNED = 'user_returned',
  USER_CONVERSATION_TAKEN_OVER = 'conversation_taken_over', // This still needs some work. We don't have this centralized.

  // user_returned:0,
  // new_user_created:0,
  // conversation_taken_over:0,

  MESSAGE = 'message',

  NLP_HANDLED = 'handled',
  NLP_UNHANDLED = 'unhandled',

  TRAINING_INTENT_LABELED = 'intent_labeled',

  EXPERIMENT_STARTED = 'started',
  EXPERIMENT_FINISHED = 'finished',
  EXPERIMENT_UNSTARTED_FINISH = 'unstarted_finish',
}